var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCustomDateIconGray = function SvgCustomDateIconGray(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect",
    d: "M14.8667 2.59998H3.13333C1.95513 2.59998 1 3.45957 1 4.51994V15.0797C1 16.1401 1.95513 16.9997 3.13333 16.9997H14.8667C16.0449 16.9997 17 16.1401 17 15.0797V4.51994C17 3.45957 16.0449 2.59998 14.8667 2.59998Z",
    stroke: "#99ABBE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M12.5547 1.00037V4.19998",
    stroke: "#99ABBE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M5.44531 1.00037V4.19998",
    stroke: "#99ABBE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    d: "M1 7.40076H17",
    stroke: "#99ABBE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCustomDateIconGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CustomDateIconGray.6335613c.svg";
export { ForwardRef as ReactComponent };